/**
 * @generated SignedSource<<8e244257f0f215818d40b948ae323f53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsRowStatus$data = {
  readonly label: string;
  readonly status: {
    readonly color: string | null;
    readonly label: string | null;
  };
  readonly subTitle: string | null;
  readonly " $fragmentType": "ProductDetailsRowStatus";
};
export type ProductDetailsRowStatus$key = {
  readonly " $data"?: ProductDetailsRowStatus$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRowStatus">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsRowStatus",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductInfoComponentStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ProductInfoComponentStatusRow",
  "abstractKey": null
};
})();

(node as any).hash = "eb4b7a871111b873a42315f46ef12301";

export default node;
